import { render, staticRenderFns } from "./bao-cao-loi-nhuan.vue?vue&type=template&id=4815e022&scoped=true&"
import script from "./bao-cao-loi-nhuan.vue?vue&type=script&lang=js&"
export * from "./bao-cao-loi-nhuan.vue?vue&type=script&lang=js&"
import style0 from "./bao-cao-loi-nhuan.vue?vue&type=style&index=0&id=4815e022&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../hoachipshop-ctv/admin-ctv/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4815e022",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../hoachipshop-ctv/admin-ctv/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VDataTable,VFlex,VLayout})
